import { VehicleOwnershipType, VehicleStatusType } from '@/enum'
import type { AssetStatus } from '@/enum/AssetStatus'
import type { OwnershipType } from '@/enum/OwnershipType'
import type { IDimensionSpecifications, IDocument, IVehicleForm } from '@/interfaces'
import type { IAppUser } from '@/interfaces/app-user/IAppUser'
import type { IDecimalValueAndUnit } from '@/interfaces/IDecimalValueAndUnit'
import type { IEngineSpecifications } from '@/interfaces/IEngineSpecifications'
import type { IFuelEconomySpecifications } from '@/interfaces/IFuelEconomySpecifications'
import type { IWheelsAndTiresSpecifications } from '@/interfaces/IWheelsAndTiresSpecifications'
import WheelsAndTiresSpecifications from '@/models/WheelsAndTiresSpecifications'
import AppUser from '../AppUser'
import Base from '../Base'
import DecimalValueAndUnit from '../DecimalValueAndUnit'
import DimensionSpecifications from '../DimensionSpecifications'
import DocumentModel from '../DocumentModel'
import EngineSpecifications from '../EngineSpecifications'
import FuelEconomySpecifications from '../FuelEconomySpecifications'

class VehicleForm extends Base implements IVehicleForm {
  title: string
  avatarUrl?: string
  registration: string
  make?: string
  model?: string
  year?: number
  type?: string
  status: AssetStatus
  assignedEmployeeId?: string
  assignedEmployee: IAppUser
  odometerReading: IDecimalValueAndUnit
  machineHours?: number
  ownership?: OwnershipType
  fitnessValidUpto?: string
  commissionDate?: string
  decommissionDate?: string
  dimensionSpecifications: IDimensionSpecifications
  fuelEconomySpecifications: IFuelEconomySpecifications
  engineSpecifications: IEngineSpecifications
  wheelsAndTiresSpecifications: IWheelsAndTiresSpecifications
  documents: IDocument[]

  constructor(vehicle?: any) {
    super(vehicle)
    this.title = vehicle?.title
    this.avatarUrl = vehicle?.avatarUrl
    this.registration = vehicle?.registration
    this.make = vehicle?.make
    this.model = vehicle?.model
    this.year = vehicle?.year
    this.type = vehicle?.type
    this.status = vehicle?.status ?? VehicleStatusType.DRAFT
    this.assignedEmployeeId = vehicle?.assignedEmployeeId
    this.assignedEmployee = new AppUser(vehicle?.assignedEmployee)
    this.odometerReading = new DecimalValueAndUnit(vehicle?.odometerReading)
    this.machineHours = vehicle?.machineHours
    this.ownership = vehicle?.ownership ?? VehicleOwnershipType.OWNED
    this.fitnessValidUpto = vehicle?.fitnessValidUpto
    this.commissionDate = vehicle?.commissionDate
    this.decommissionDate = vehicle?.decommissionDate
    this.dimensionSpecifications = new DimensionSpecifications(vehicle?.dimensionSpecifications)
    this.fuelEconomySpecifications = new FuelEconomySpecifications(
      vehicle?.fuelEconomySpecifications
    )
    this.engineSpecifications = new EngineSpecifications(vehicle?.engineSpecifications)
    this.wheelsAndTiresSpecifications = new WheelsAndTiresSpecifications(
      vehicle?.wheelsAndTiresSpecifications
    )
    this.documents = vehicle?.documents?.map((document: any) => new DocumentModel(document)) ?? []
  }
}

export default VehicleForm
